import React, { useState, useEffect } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import "./IncomeAndExpense.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { FaArrowRight } from "react-icons/fa";

const IncomeAndExpenses = ({ data }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(data);
  const [seeList, setSeeList] = useState(false);
  const [incomeAndExpenseList, setIncomeAndExpenseList] = useState([]);
  const [incomeAndExpenseTotal, setIncomeAndExpenseTotal] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [objincomeAndExpenses, setObjIncomeAndExpenses] = useState({
    incomeAndExpenses: "",
    createAt: "",
    description: "",
    amount: "",
    userId: user && user.id ? user.id : "1",
  });

  const viewList = () => {
    setSeeList(true);
  };

  const cancelviewList = () => {
    setSeeList(false);
  };

  const reloadChildData = () => {
    setReloadData((prevReloadData) => !prevReloadData);
  };

  const handlerCreate = async (e) => {
    e.preventDefault();
    const endpoint = `${process.env.REACT_APP_LEALTAD_INCOME_AND_EXPENSES}`;
    const isIncome = objincomeAndExpenses.incomeAndExpenses === "Ingresos";
    try {
      const res = await axios.post(endpoint, {
        objincomeAndExpenses,
      });
      const successMessage = isIncome
        ? "Se creó el ingreso con éxito"
        : "Se creó el egreso con éxito";

      if (res.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: successMessage,
        });
      }
      reloadChildData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de llenar el Formulario",
      });
    }
  };

  const resetForm = () => {
    setUser(data);
    setObjIncomeAndExpenses({
      incomeAndExpenses: "",
      createAt: "",
      description: "",
      amount: "",
      userId: user && user.id ? user.id : "1",
    });
  };

  const handleClick = (e) => {
    e.preventDefault();
    handlerCreate(e);
    resetForm();
  };

  useEffect(() => {
    // Verificar si user tiene un valor definido
    if (user) {
      const userId = user.id;
      const apiUrl = `${process.env.REACT_APP_LEALTAD_INCOME_AND_EXPENSES}?userId=${userId}`;

      const fetchData = async () => {
        try {
          const response = await axios.get(apiUrl);
          // Verificar si la respuesta es un 404 (No hay ingresos y egresos)
          if (response.status === 204) {
            // Actualizar el estado de ingresos y egresos a un arreglo vacío
            setIncomeAndExpenseList([]);
            setIncomeAndExpenseTotal([]);
          } else {
            setIncomeAndExpenseList(response.data.userIncomeAndExpenses);
            setIncomeAndExpenseTotal(response.data.userTotal.totalBalance);
          }
        } catch (error) {
          setIncomeAndExpenseList([]);
          setIncomeAndExpenseTotal([]);
        }
      };

      fetchData();
    }
  }, [data, reloadData, user]);
  const handleIncome = async (data) => {
    navigate("/lealtad/detalle-ingresos-egresos", { state: data });
  };

  return (
    <div className={styles.LealtadinformacionPolitica} id="income">
      <div
        className={styles.LealtadsectionTitle2}
        id={"box_buttonflexcollum-lealtad"}
      >
        <div className={styles.LealtadsectionTitle3}>
          <h2 className={styles.LealtadsectionTitleH2}>
            Pagos y Cobros con la Mutual
          </h2>
          <IconAnimation />
        </div>
        <div className={styles.LealtadbuttonsContainer}>
          <button
            type="button"
            id={styles.Lealtadbuttonmrd}
            className={styles.Lealtadbutton}
            onClick={() => handleIncome(data)}
          >
            <i className="fa fa-refresh-lealtad"></i> Ver Pagos <br />y Cobros
            <FaArrowRight className={styles.Lealtadicon} />
          </button>
        </div>
      </div>
      {!user ? (
        <NotReportViewData
          title="Pagos y Cobros con la Mutual"
          Icon={HiClipboardDocumentList}
        />
      ) : (
        <div className="box_all_ing_eg-lealtad">
          <div className="display_selec_date-lealtad">
            <select
              className="select_ig_eg-lealtad"
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  incomeAndExpenses: e.target.value,
                })
              }
              value={objincomeAndExpenses.incomeAndExpenses}
            >
              <option>Seleciona un valor</option>
              <option value="Ingresos">Ingresos</option>
              <option value="Egresos">Egresos</option>
            </select>
            <input
              className="select_ig_eg-lealtad"
              type="date"
              value={objincomeAndExpenses.createAt || ""}
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  createAt: e.target.value,
                })
              }
            />
            <input
              className="select_ig_eg-lealtad"
              type="number"
              placeholder="Monto"
              value={objincomeAndExpenses.amount || ""}
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  amount: e.target.value,
                })
              }
            />
          </div>
          <div>
            <textarea
              className="text_area_ig_eg-lealtad"
              placeholder="Ingrese una Descripcion del archivo"
              value={objincomeAndExpenses.description || ""}
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  description: e.target.value,
                })
              }
            ></textarea>
          </div>
          <div className="box_button_ig_eg-lealtad">
            <button
              className="button_ig_eg-lealtad"
              type="button"
              onClick={(e) => handleClick(e)}
            >
              Crear
            </button>
            {seeList === false ? (
              <button
                className="button_ig_eg-lealtad"
                type="button"
                id="botton_ig_eg_two-lealtad"
                onClick={viewList}
              >
                Ver Mas
              </button>
            ) : (
              <button
                className="button_ig_eg-lealtad"
                type="button"
                id="botton_ig_eg_two-lealtad"
                onClick={cancelviewList}
              >
                Ver Menos
              </button>
            )}
          </div>
          {seeList === true ? (
            <>
              <div className="list_reports_ig_eg-lealtad">
                <div className="scrool_ig_eg-lealtad">
                  {incomeAndExpenseList.length === 0 ? (
                    <p>No hay ingresos/egresos disponibles de este mes.</p>
                  ) : (
                    incomeAndExpenseList.map((item, index) => (
                      <div className="reports_ig_eg-lealtad" key={index}>
                        <div className="width_ig_ig_eg first_three-lealtad">
                          <p className="ig_eg_p_data-lealtad">
                            {item.incomeAndExpenses}
                          </p>
                        </div>
                        <div className="width_ig_ig_eg first_three-lealtad">
                          <p className="ig_eg_p_data-lealtad">
                            {item.createAt}
                          </p>
                        </div>
                        <div className="width_ig_ig_eg first_three-lealtad">
                          <p className="ig_eg_p_data-lealtad">
                            {"$" + item.amount}
                          </p>
                        </div>
                        <div className="width_ig_ig_eg-lealtad">
                          <p className="ig_eg_p_data-lealtad">
                            {item.description}
                          </p>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <div className="total_ig_eg-lealtad">
                  <div className="ig_eg_total-lealtad">
                    <p className="ig_eg_p_data-lealtad">
                      Monto Total: {incomeAndExpenseTotal}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default IncomeAndExpenses;
